import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(4)
  },
  h2Root: {
    fontSize: '28px',
    flexGrow: 1
  },
  cardActionsRoot: {
    padding: 0,
    marginBottom: theme.spacing(4)
  }
}));
